import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 1.67 3.36',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M1.61,3.36H.06A.06.06,0,0,1,0,3.3V.83A.83.83,0,0,1,1.42.24a.87.87,0,0,1,.25.53.07.07,0,0,1-.06.07A.07.07,0,0,1,1.54.78a.69.69,0,0,0-.2-.45A.75.75,0,0,0,.83.12.71.71,0,0,0,.12.83V3.24H1.55V1.76a.06.06,0,0,1,.06-.06.06.06,0,0,1,.06.06V3.3A.06.06,0,0,1,1.61,3.36Z"
        />
        <path
          fill={fill}
          d="M1.42.92a.36.36,0,0,1-.25-.1.05.05,0,0,1,0-.08.06.06,0,0,1,.09,0,.23.23,0,0,0,.31,0,.07.07,0,0,1,.09,0,.07.07,0,0,1,0,.09A.32.32,0,0,1,1.42.92Z"
        />
        <path
          fill={fill}
          d="M1.61,1.82a.05.05,0,0,1-.06-.06c0-.29-.24-.38-.45-.45L.94,1.24l-.1-.05C.63,1.1.4,1,.4.78A.44.44,0,0,1,.83.34a.44.44,0,0,1,.44.44.06.06,0,0,1-.06.06A.06.06,0,0,1,1.15.78a.32.32,0,1,0-.63,0c0,.13.2.22.37.3l.1,0a.67.67,0,0,0,.15.06c.22.09.53.2.53.57A.06.06,0,0,1,1.61,1.82Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
